import { useOnCrmMessageTopic } from 'crm-message-bus/useOnCrmMessageTopic';
import DefaultCardAction from '../default/DefaultCardAction';
import useHasCompletedPaymentsApplication from './hooks/useHasCompletedPaymentsApplication';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { COMMERCE_PAYMENT_TYPE_ID, INVOICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
const CommercePaymentCardAction = args => {
  const {
    onRefetchLegacySidebar,
    refetchObjectData
  } = args;
  const {
    completedApplication
  } = useHasCompletedPaymentsApplication();
  useOnCrmMessageTopic(TOPIC_NAMES.UPDATE_OBJECT, objectData => {
    if (objectData.objectTypeId === COMMERCE_PAYMENT_TYPE_ID) {
      if (onRefetchLegacySidebar) onRefetchLegacySidebar();
      if (refetchObjectData) refetchObjectData().catch(error => {
        Raven.captureException(error);
        throw new Error('No data returned from refetchObjectData query');
      });
    }
  });
  const isFromInvoice = args.fromObjectTypeId === INVOICE_TYPE_ID;
  const canEditAssociation = isFromInvoice ? false : args.canEditAssociation;
  const canEditAssociationMessageOverride = isFromInvoice ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "cardAssociatedObjects.AssociateObjectButton.tooltip.commercePaymentFromInvoiceTooltipTextRecordOverride"
  }) : undefined;
  return completedApplication ? /*#__PURE__*/_jsx(DefaultCardAction, Object.assign({}, args, {
    canEditAssociation: canEditAssociation,
    canEditAssociationMessageOverride: canEditAssociationMessageOverride
  })) : null;
};
export default CommercePaymentCardAction;